export default "__VITE_ASSET__BE_Teq7E__"